import { CarInsuranceAdLandingHero, CarInsuranceAdLandingDetails } from '../components/CarInsuranceAdLandingContent';
import '../components/CarInsuranceAdLandingContent.css';

function CarInsuranceAdLandingPage() {
  return (
    <div className="container car-ad-landing-page">
      <CarInsuranceAdLandingHero />
      <div className="car-ad-form-details-divider" aria-hidden="true">
        <span>Learn more</span>
      </div>
      <CarInsuranceAdLandingDetails />
    </div>
  );
}

export default CarInsuranceAdLandingPage;
